module.exports = __webpack_public_path__ + "img/BV.38cd1c22.png";